import { render, staticRenderFns } from "./AnamneseEdit.vue?vue&type=template&id=6c64dc60&"
import script from "./AnamneseEdit.js?vue&type=script&lang=js&"
export * from "./AnamneseEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports